import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import styled from 'styled-components';

import { Checkbox } from '../../utilites';

import CrossIcon from '../../../assets/icons/cross.svg';

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  column-gap: 15px;
  max-height: 400px;
`;

const ListRow = styled.div`
  display: flex;
`;

const LetterBox = styled.div`
  width: 25px;
  margin-right: 10px;
  color: #ccc;
`;

const FilterBox = styled.div``;

const FilterModal = ({ isOpen, title, options, selectedValues, onClose, onSubmit }) => {
  const [_selectedValues, _setSelectedValues] = useState(selectedValues);

  useEffect(() => {
    _setSelectedValues(selectedValues);
  }, [selectedValues]);

  const onChange = (value) => {
    _setSelectedValues({ ..._selectedValues, [value]: !_selectedValues[value] });
  };

  const onFinalChange = () => {
    onSubmit(_selectedValues);
  };

  const classNameFilter = options?.length > 15 || (options?.length > 2 && options?.some(option => option.groups.length > 15)) ? 'modal-container modal-search' : 'modal-container'

  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className={classNameFilter}
      overlayClassName="modal-overlay">
      <div className="modal-header">
        <h2>{title}</h2>
        <button className="button-icontrigger modal-closetrigger" onClick={onClose}>
          <span className="icon">
            <CrossIcon />
          </span>
        </button>
      </div>
      <ModalBody className="modal-body">
        {options &&
          options.length !== 0 &&
          options.map(({ letter, groups }) => (
            <div key={letter} className="m-b-spacer-1">
              {groups.map((item, itemIdx) => (
                <ListRow key={item.value}>
                  <LetterBox>{itemIdx === 0 ? letter : ''}</LetterBox>
                  <FilterBox>
                    <Checkbox
                      label={item.label}
                      onChange={() => onChange(item.value)}
                      value={_selectedValues[item.value]}
                    />
                  </FilterBox>
                </ListRow>
              ))}
            </div>
          ))}
      </ModalBody>
      <div className="modal-footer">
        <button className="button" type="button" onClick={onFinalChange}>
          Применить
        </button>
      </div>
    </ReactModal>
  );
};

export default FilterModal;
